import { Box } from '@mui/material'
import { GolfTournamentWithFeedCount } from '@/stores/tournaments/tournaments.utils'
import { isMatchPlay, isStrokePlay } from '@/utils/_legacy/getGolfFormats/getGolfFormats'

import { matchPlayWebsockets, strokePlayWebsockets } from './constants'
import { WebsocketStatus, WebsocketStatusContainer } from './TournamentWebsocketsStatus.styles'

const TournamentWebsocketsStatus = ({
  tournament
}: {
  tournament: GolfTournamentWithFeedCount
}) => {
  const {
    format,
    count: { matchByInternalId }
  } = tournament

  const tournamentWebsockets: Record<string, string> = isStrokePlay(format)
    ? strokePlayWebsockets
    : isMatchPlay(format)
      ? matchPlayWebsockets
      : {}

  return (
    <Box style={{ display: 'flex' }} data-testid="websockets-container">
      {matchByInternalId &&
        Object.keys(tournamentWebsockets).map((websocket) => (
          <WebsocketStatusContainer key={websocket}>
            <WebsocketStatus
              active={'feedCounts' in matchByInternalId}
              data-testid={`${websocket}-status`}
            />
            <p>{tournamentWebsockets[websocket]}</p>
          </WebsocketStatusContainer>
        ))}
    </Box>
  )
}

export default TournamentWebsocketsStatus
